import { createContext, useContext, useState, useEffect } from "react";
import { metricsService } from "../services/metricsService";

const MetricsContext = createContext();


export const useMetrics = () => {
    return useContext(MetricsContext);
}

export const MetricsProvider = ({ children }) => {

    //Selected location
    const [currentLocation, setCurrentLocation] = useState(null);
    const [currentLocationIndex, setCurrentLocationIndex] = useState(0);




    const [otsByAssetLocationAndStatus, setOtsByAssetLocationAndStatus] = useState(null);
    const [loadingOtsByAssetLocationAndStatus, setLoadingOtsByAssetLocationAndStatus] = useState(false);
    const getOtsByAssetLocationAndStatus = async (params) => {
        try {
            setLoadingOtsByAssetLocationAndStatus(true);
            const response = await metricsService.getOtByAssetLocationAndStatus(params);
            setOtsByAssetLocationAndStatus(response.data);
            setLoadingOtsByAssetLocationAndStatus(false);
        } catch (error) {
            console.error(error);
            setLoadingOtsByAssetLocationAndStatus(false);
        }
    }


    const [tasksByTechnician, setTasksByTechnician] = useState([]);
    const [loadingTasksByTechnician, setLoadingTasksByTechnician] = useState(false);
    const getTasksByTechnician = async (params) => {
        try {
            setLoadingTasksByTechnician(true);
            const response = await metricsService.getTasksByTechnician(params);
            setTasksByTechnician(response.data);
            console.log(response.data);
            setLoadingTasksByTechnician(false);
        } catch (error) {
            console.error(error);
            setLoadingTasksByTechnician(false);
        }
    }


    const [otMetricsByLocation, setOtMetricsByLocation] = useState([]);
    const [loadingOtMetricsByLocation, setLoadingOtMetricsByLocation] = useState(false);
    const getOtMetricsByLocation = async () => {
        try {
            setLoadingOtMetricsByLocation(true);
            const response = await metricsService.getOtMetricsByLocation();
            setOtMetricsByLocation(response.data);
            setLoadingOtMetricsByLocation(false);
            console.log(response.data);
        } catch (error) {
            console.error(error);
            setLoadingOtMetricsByLocation(false);
        }
    }

    const [rootLocations, setRootLocations] = useState([]);
    const [loadingRootLocations, setLoadingRootLocations] = useState(false);
    const getRootLocations = async () => {
        try {
            setLoadingRootLocations(true);
            const response = await metricsService.getRootLocations();
            setRootLocations(response.data);
            setLoadingRootLocations(false);
        } catch (error) {
            console.error(error);
            setLoadingRootLocations(false);
        }
    }
 
    const [tasksScheduledPerMonth, setTasksScheduledPerMonth] = useState([]);
    const [loadingTasksScheduledPerMonth, setLoadingTasksScheduledPerMonth] = useState(false);
    const getTasksScheduledPerMonth = async (month) => {
        try {
        setLoadingTasksScheduledPerMonth(true);
        const response = await metricsService.getTasksScheduledPerMonth(month);
            setTasksScheduledPerMonth(response.data);
            setLoadingTasksScheduledPerMonth(false);
            console.log(response.data);
        } catch (error) {
            console.error(error);
            setLoadingTasksScheduledPerMonth(false);
        }
    }

    const [tasksNotScheduledPerMonth, setTasksNotScheduledPerMonth] = useState([]);
    const [loadingTasksNotScheduledPerMonth, setLoadingTasksNotScheduledPerMonth] = useState(false);
    const getTasksNotScheduledPerMonth = async (month) => {

        console.log(month);
        try {
            setLoadingTasksNotScheduledPerMonth(true);
            const response = await metricsService.getTasksNotScheduledPerMonth(month);
            setTasksNotScheduledPerMonth(response.data);
            setLoadingTasksNotScheduledPerMonth(false);
            console.log(response.data);
        } catch (error) {
            console.error(error);
            setLoadingTasksNotScheduledPerMonth(false);
        }
    }

    const [otsWithTasksScheduledByStatus, setOtsWithTasksScheduledByStatus] = useState([])
    const [loadingOtsWithTasksScheduledByStatus, setLoadingOtsWithTasksScheduledByStatus] = useState(false)
    const getOtsWithTasksScheduledByStatus = async () => {
        try {
            setLoadingOtsWithTasksScheduledByStatus(true)
            const response = await metricsService.getOtsWithTasksScheduledByStatus();
            setOtsWithTasksScheduledByStatus(response.data)
            setLoadingOtsWithTasksScheduledByStatus(false)
        }
        catch (error) {
            console.log(error)
            setAlertSnackbar({
                open: true,
                message: error.response.data.message,
                severity: 'error'
            })
        }
    }

    return <MetricsContext.Provider value={{ 
        otsByAssetLocationAndStatus, 
        loadingOtsByAssetLocationAndStatus, 
        getOtsByAssetLocationAndStatus,
        tasksByTechnician,
        loadingTasksByTechnician,
        getTasksByTechnician,
        otMetricsByLocation,
        loadingOtMetricsByLocation,
        getOtMetricsByLocation,
        rootLocations,
        loadingRootLocations,
        getRootLocations,
        currentLocation,
        currentLocationIndex,
        setCurrentLocation,
        setCurrentLocationIndex,
        tasksScheduledPerMonth,
        loadingTasksScheduledPerMonth,
        getTasksScheduledPerMonth,
        tasksNotScheduledPerMonth,
        loadingTasksNotScheduledPerMonth,
        getTasksNotScheduledPerMonth,
        otsWithTasksScheduledByStatus,
        loadingOtsWithTasksScheduledByStatus,
        getOtsWithTasksScheduledByStatus
    }}>{children}</MetricsContext.Provider>
}